exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mask[data-v-3487f0fc]{top:0;bottom:0;z-index:100;background-color:hsla(0,0%,100%,.4)}.mask[data-v-3487f0fc],.mask img[data-v-3487f0fc]{position:absolute;left:0;right:0}.mask img[data-v-3487f0fc]{width:60px;height:60px;top:40%;margin:auto;display:block}", ""]);

// exports
